import { observeQuickView } from "./observeQuickView";

export const customAside = () => {
  document.addEventListener("click", (event) => {
    const openTrigger = event.target.closest("[data-aside-open]");
    const closeTrigger = event.target.closest(".custom-aside__close");
    const overlay = document.querySelector(".aside-overlay");
    const overlayQuickView = document.querySelector(
      ".aside-overlay--quickview"
    );

    if (openTrigger) {
      const targetKey = openTrigger.getAttribute("data-aside-open");
      const targetAside = document.querySelector(
        `.custom-aside[data-aside="${targetKey}"]`
      );

      if (targetAside) {
        targetAside.classList.add("isActive");

        if (targetKey.includes("quickview")) {
          overlayQuickView.classList.add("isActive");
        } else {
          overlay.classList.add("isActive");
        }
      }
    }

    if (
      closeTrigger ||
      event.target === overlay ||
      event.target === overlayQuickView
    ) {
      const activeAside = document.querySelector(".custom-aside.isActive");
      const activeOverlayAside = document.querySelector(
        ".aside-overlay.isActive"
      );

      if (activeAside) {
        activeAside.classList.remove("isActive");
        activeOverlayAside.classList.remove("isActive");

        if (overlayQuickView.classList.contains("isActive")) {
          overlayQuickView.classList.remove("isActive");
        } else {
          overlay.classList.remove("isActive");
        }
      }
    }
  });

  observeQuickView();
};
